export default "__VITE_ASSET__C_UAhS6G__"